<template>
  <assembleia-list
    :assembleias="assembleias"
    :title="'Assembleias'"
    :subtitle="
      'Cadastre assebleias e enquetes e mantenha a participação ativa de toda sua comunidade.'
    "
    @assembleiaClick="visualizarAssembleia"
  />
</template>

<script>
import AssembleiaAPI from '@/api/assembleia'
import AssembleiaList from '../components/AssembleiaList.vue'

export default {
  components: {
    AssembleiaList,
  },
  data() {
    return {
      assembleias: [],
    }
  },
  created() {
    this.listAssembleia()
  },
  methods: {
    visualizarAssembleia(id) {
      this.$router.push(`/assembleias/edit/${id}`).catch(() => {})
    },
    listAssembleia() {
      this.$loading.show()
      AssembleiaAPI.listAssembleia()
        .then(res => {
          this.$loading.hide()
          this.assembleias = res.data.content
        })
        .catch(() => this.$loading.hide())
    },
    novaAssembleia() {
      this.$router.push('/assembleias/edit').catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.top-1-right-1 {
  top: 10px;
  right: 10px;
  position: absolute;
}
</style>
